const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 4.03h-7v-1c0-1.66-1.34-3-3-3s-3 1.34-3 3v1H2c-.55 0-1 .45-1 1s.45 1 1 1h1v15c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-15h1c.55 0 1-.45 1-1s-.45-1-1-1zm-11-1c0-.55.45-1 1-1s1 .45 1 1v1h-2zm8 18c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-15h14z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 20.03c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1zM12 20.03c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1zM16 20.03c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1z"
});

const SvgDelete = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.5c0a1adc.svg";
export { ForwardRef as ReactComponent };